import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AzureAuthService } from './azure-auth.service';

/**
 * Runs before MsalInterceptor (see provider order in app.module.ts).
 * When the app is in anonymous mode (e.g. public dashboards), bypasses the
 * entire remaining interceptor chain by going directly to HttpBackend, so
 * MsalInterceptor never sees the request and cannot trigger a login popup.
 */
@Injectable()
export class PublicBypassInterceptor implements HttpInterceptor {
  constructor(private authService: AzureAuthService, private httpBackend: HttpBackend) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.authService.anon) {
      return this.httpBackend.handle(request);
    }
    return next.handle(request);
  }
}
